import React, { useState } from "react";
import logo from "../../../images/Damas_univ.png";
import trueimg from "./../../../images/true.png";
import Title from "../../Title/Title";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Search from "../../Search/Search";
import Selected from "../../Inputs/Selected";

interface StudentsRegisteredProps {}

const StudentsRigester: React.FC<StudentsRegisteredProps> = () => {
  const [popup, setpopup] = useState<number | boolean>();

  const handleClosePopup = () => {
    setpopup(-1);
  };

  return (
    <>
      <Row>
        <Col>
          <Title title=" الطلاب المستجدين" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="اسم الطالب / اسم الاب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> التسلسل </td>
                <td>الاسم والنسبة</td>
                <td> الاب </td>
                <td> الام </td>
                <td> نوع الثانوية </td>
                <td> نوع التفاضل </td>
                <td>العمليات</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td className="text-2xl">0000</td>
                <td className="text-2xl"> الاحمد أحمد</td>
                <td className="text-2xl">احمد</td>

                <td className="text-2xl"> خلود </td>
                <td className="text-2xl"> علمي </td>
                <td className="text-2xl"> العامة </td>
                <td className="flex flex-col">
                  <button
                    className=" bg-[#efc5e6] p-2 rounded-2xl mt-4"
                    onClick={() => setpopup(1)}
                  >
                    تدقيق البيانات
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>

      {popup === 1 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative p-5 bg-white w-[900px] h-[80vh] max-lg:w-[80%] max-md:w-full overflow-y-scroll  border-2 border-white rounded-lg "
            >
              <div
                className="absolute cursor-pointer top-5 hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>
              <Row>
                <Col lg={12} className="flex justify-center !mt-2">
                  <Title title="تدقيق البيانات (اسم الطالب)" />
                </Col>
              </Row>
              <Row>
                <Col lg={12} className="flex justify-center h-[35vh] ">
                  <div className="fixed">
                    <img src={logo} alt="" className="w-[300px]" />
                  </div>
                </Col>
              </Row>

              {/* <Row justify={"around"} className="!mt-5">
                <Col lg={4} md={5} sm={10} className="flex justify-center ">
                  <AddImage
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    title="صورة الهوية"
                    name="file"
                    className="!bg-Main w-full h-12 "
                    onChange={(e) => {
                      // setSuccessPost(0);
                      // handleChangeInput(e);
                    }}
                  />  
                </Col>
              </Row> */}

              <Row justify={"around"}>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="  الاسم الاول" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="  النسبة" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="  اسم الاب" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="   اسم الام" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="  مكان الميلاد" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="   تاريخ الميلاد" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="   الرقم الوظني" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="  مكان القيد" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder="   رقم القيد" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder=" الجنس" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder=" الجنسية" />
                </Col>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder=" شعبة التجنيد" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={4} md={5} sm={10}>
                  <Input placeholder=" رقم جواز السفر (لغير السوريين)" />
                </Col>
                <Col lg={4} md={5} sm={10}></Col>
                <Col lg={4} md={5} sm={10}></Col>
              </Row>
              <Col className="flex justify-evenly !mt-4 ">
                <Col lg={5} md={5} sm={5}>
                  <MainButton
                    titlebtn="متابعة"
                    className="w-full"
                    onClick={() => setpopup(2)}
                  />
                </Col>

                <Col lg={5} md={5} sm={6}>
                  <MainButton
                    titlebtn="ارسال طلب تعديل"
                    className="w-full !bg-gray-200 !text-Secondary"
                    onClick={() => setpopup(20)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {popup === 2 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative p-5 bg-white w-[700px] h-[70vh] max-md:overflow-y-scroll   border-2 border-white rounded-lg  "
            >
              <div
                className="absolute top-5 cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>
              <Row>
                <Col lg={12} className="flex justify-center !mt-2">
                  <Title title="  بيانات الطالب الشخصية" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={5} sm={10}>
                  <Input placeholder="   رقم الموبايل" />
                </Col>
                <Col lg={5} sm={10}>
                  <Input placeholder="  رقم الهاتف" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={5} sm={10}>
                  <Input placeholder="    دولة الاقامة" />
                </Col>
                <Col lg={5} sm={10}>
                  <Input placeholder="   مدينة الاقامة" />
                </Col>
              </Row>
              <Row justify={"around"}>
                <Col lg={5} sm={10}>
                  <Input placeholder="    العنوان الدائم" />
                </Col>
                <Col lg={5} sm={10}>
                  <Input placeholder="   العنوان الحالي" />
                </Col>
              </Row>

              <Col className="flex justify-around !mt-4 ">
                <Col lg={5} md={5} sm={6}>
                  <MainButton
                    titlebtn="متابعة"
                    className="w-full"
                    onClick={() => setpopup(3)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {popup === 3 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative p-5 bg-white w-[900px] h-[90vh] max-lg:w-[80%] max-md:w-full overflow-y-scroll  border-2 border-white rounded-lg "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Row>
                <Col lg={12} className="flex justify-center !mt-2">
                  <Title title="  معلومات الشهادة الثانوية" />
                </Col>
              </Row>

              <Row justify={"around"} className="!mt-1">
                <Col lg={12} md={12} sm={12} className="flex justify-center ">
                  {/* <AddImage
                    type="IMAGES"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    title="  صورة الشهادة"
                    name="file"
                    className="!bg-Main w-full h-12 "
                    onChange={(e) => {
                      // setSuccessPost(0);
                      // handleChangeInput(e);
                    }}
                  /> */}
                </Col>
              </Row>

              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   نوع الشهادة" />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="  مصدر الشهادة" />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   علامة اللغة الانكليزية" />
              </Col>

              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   علامة اللغة الفرنسية " />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder=" علامة التربية الدينية  " />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   لغة الطالب " />
              </Col>

              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   معدل التفاضل " />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   اسم المعهد" />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="     اسم الشخص" />
              </Col>

              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   عام التخرج" />
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Input placeholder="   المعدل العام " />
              </Col>
              <Col lg={4} md={4} sm={6}></Col>

              <Col className="flex justify-around !mt-4 ">
                <Col lg={5} md={5} sm={5}>
                  <MainButton
                    titlebtn="متابعة"
                    className="w-full"
                    onClick={() => setpopup(4)}
                  />
                </Col>

                <Col lg={5} md={5} sm={6}>
                  <MainButton
                    titlebtn="ارسال طلب تعديل"
                    className="w-full !bg-gray-200 !text-Secondary"
                    onClick={() => setpopup(5)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {popup === 4 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative  bg-white w-[500px] max-lg:w-[80%] max-md:w-full h-[50vh]   border-2 border-white rounded-lg "
            >
              <div
                className="absolute  top-5  cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <div className="icons flex justify-center items-center !mt-5 ">
                <img src={trueimg} alt="" />
              </div>
              <Row>
                <Col lg={12} className="flex justify-center !mt-7">
                  <Title
                    title="لقد تم تفعيل حساب الطالب بنجاح"
                    className="!cursor-default"
                  />
                </Col>
              </Row>

              <Col className="flex justify-evenly  ">
                <Col lg={3} md={5} sm={4}>
                  <MainButton
                    titlebtn="تم"
                    className="w-[100%] "
                    onClick={handleClosePopup}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {popup === 5 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative bg-white w-[500px] h-[60vh] max-lg:w-[80%] max-md:w-full  overflow-y-scroll  border-2 border-white rounded-lg "
            >
              <div
                className="absolute top-5   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>
              <Row>
                <Col lg={12} className="flex justify-center !mt-5">
                  <Title
                    title=" قم بتحديث الجهات التي تريد ارسال الاشعار عليها"
                    className="!text-2xl max-md:!text-xl"
                  />
                </Col>
              </Row>

              <Col lg={8} md={5} sm={10}>
                <Selected title="كل طلاب الجامعة">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </Selected>
              </Col>

              <Col lg={8} md={5} sm={10}>
                <Input placeholder="  ادخال ارقام الطالب الامتحانية  " />
              </Col>

              <Col lg={8} md={5} sm={10}>
                <Input placeholder="    نص الاشعار باللغة العربية " />
              </Col>

              <Col lg={8} md={5} sm={10}>
                <Input placeholder="    نص الاشعار باللغة الانكليزية " />
              </Col>

              <Col className="flex justify-evenly !mt-4 ">
                <Col lg={5} md={5} sm={4}>
                  <MainButton
                    titlebtn="ارسال  "
                    className="w-full"
                    onClick={() => setpopup(6)}
                  />
                </Col>
                <Col lg={5} md={5} sm={4}>
                  <MainButton
                    titlebtn="الغاء"
                    className="w-full !bg-gray-200 !text-Secondary"
                    onClick={() => setpopup(-1)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {popup === 6 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"start"}
              className="relative bg-white w-[500px] h-[50vh]   border-2 border-white rounded-lg "
            >
              <div
                className="absolute top-5   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>
              <div className="icons flex justify-center items-center !mt-7 ">
                <img src={trueimg} alt="" />
              </div>
              <Row>
                <Col lg={12} className="flex justify-center !mt-3">
                  <Title title="لقد تم ارسال الاشعار بنجاح" />
                </Col>
              </Row>
              <Col className="flex justify-evenly  ">
                <Col lg={5} md={5} sm={5}>
                  <MainButton
                    titlebtn="تم"
                    className="w-[100%] "
                    onClick={handleClosePopup}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {popup === 20 && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"start"}
              className="relative bg-white w-[500px] h-[40vh]   border-2 border-white rounded-lg "
            >
              <div
                className="absolute top-5   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Row justify={"center"}>
                <Col lg={12} className="flex justify-center !mt-3">
                  <Title title="ارسال رسالة للطالب" />
                </Col>
                <Col lg={10} className="flex justify-center ">
                  <Input placeholder="  ادخل الرسالة" className="w-[400px] m" />
                </Col>
              </Row>
              <Col className="flex justify-evenly  ">
                <Col lg={5} md={5} sm={5}>
                  <MainButton
                    titlebtn="ارسال"
                    className="w-[100%] "
                    onClick={() => setpopup(6)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default StudentsRigester;
